$(document).ready(function(){


  //language - select
  if ($('.languageBox__select').length) {
    $('.languageBox__select').on('click', function() {
        $('.languageBox__list').toggleClass('visible');
        $(this).toggleClass('open');
        return false;
    });
  }

  $('.header__login-withSubmenu').on('click', function(){
      $('.header__login-submenu').slideToggle(300);
  });

  $('.myAcc').on('click', function(){
      event.preventDefault();
  });



  //aos
  if ( $('[data-aos]').length ) {
      AOS.init({
          offset: 50,
          duration: 500
      });
  }

  // lazy loads elements with default selector as '.lozad'
  if ($('.lozad').length) {
    const observer = lozad();
    observer.observe();
  }

  // Handle Lazy loading on page print
  window.onbeforeprint = function() {
    $('.lozad').each(function() {
      var src = $(this).attr('data-src');
      $(this).attr('src', src).parent().addClass('loaded');
    });
  };


  // relax init
  if ($('.rellax').length) {
      var rellax = new Rellax('.rellax', {
        wrapper: '.rellax-parent',
        relativeToWrapper: true,
      });
  }

  // js-up
  $(".js-up").on("click", function () {
      var body = $("html, body");
      body.stop().animate({scrollTop: 0}, 1500, 'swing');
  });

  //search
  $('.js-header__search').on('click', function(){
      $('.header .searchBox').slideToggle(300);
  });
  $('.header .searchBox .searchBox__close').on('click', function(){
      $('.header .searchBox').slideToggle(300);
  });

  $('.searchBoxIcon').on('click', function(){
    $('[data-search-form]').submit();
  });


}); // end document ready

$(window).on("scroll", function () {

// js-up
var scroll = $(window).scrollTop();
if (scroll > 600) {
    $(".js-up").addClass("visible");
} else {
    $(".js-up").removeClass("visible");
}

// scrolled menu
if ($(window).scrollTop() > 0){
  $('.js-header').addClass('header--scrolled');
}else{
  $('.js-header').removeClass('header--scrolled');
}

}); // end onscroll
